import PL_utils from './vendor/pl-utils.js';

const links = document.querySelectorAll('a');

export default () => {
    PL_utils.eleOnClick(function (e) {
        // Make sure href has a value before overriding default behavior
        let hash = e.currentTarget.getAttribute('href');
        
        if (hash !== '' && hash.charAt(0) == '#') {
            //exclude skiptocontent from smoothscroll
            if(hash == '#Content'){
                return;
            }
            // Prevent default anchor click behavior
            e.preventDefault();

            // find the hash location
            //scroll
            document.querySelector(hash).scrollIntoView({
                behavior: 'smooth'
            });
        }
    }, links);

};